import React from 'react'
import ModalFormUI from '../../widgets/form/ModalFormUI'
import InputSelectUI from '../../widgets/form/InputSelectUI'

const AccountUserUpdateModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onConfirmUpdateClick, onCancelClick,
    // field
    roleId, roleList, onRoleIdChange, roleIdError,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_update_users'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onConfirmUpdateClick}
    busy={submitted}
  >
    <InputSelectUI name='roleId' value={roleId} required={true}
      messageList={messageList} labelKey='c_new_role'
      optionList={roleList}
      onChange={onRoleIdChange} error={roleIdError}
    />
  </ModalFormUI>

export default AccountUserUpdateModalUI
